import FilterCheckbox from "@/theme1/components/shop/FilterCheckbox";

export default function FilterGroup({ group, selected = [], onChange }) {
  return (
    <div className="border-b border-border/60 py-5 last:border-b-0">
      <h3 className="mb-3 text-sm font-semibold tracking-tight text-foreground">
        {group.label}
      </h3>

      <div className="space-y-1">
        {group.options.map((option) => (
          <FilterCheckbox
            key={option}
            label={option}
            checked={selected.includes(option)}
            onChange={() => onChange(group.id, option)}
          />
        ))}
      </div>
    </div>
  );
}